var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"skeleton animate-pulse",style:({ height: _vm.height, width: _vm.width, borderRadius: _vm.shape })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }